import { Tabs } from 'antd';
import style from './Wrapper.module.less';

type WrapperTab = {
  label: string;
  value: string;
}
interface WrapperProps {
  type?: 'card' | 'tabs';
  title?: string;
  className?: string;
  children?: React.ReactNode[] | React.ReactNode;
  tabs?: WrapperTab[];
  subTitle?: React.ReactNode[] | React.ReactNode;
}

const Wrapper: React.FC<WrapperProps> = props => {
  return (
    <div className={`${style[props.type as string]} ${style.wrapper} ${props.className}`}>
      {
        props.type === 'card' && (
          <>
            <div className={style.title}>
              <span>{props.title}</span>
              {props.subTitle}
            </div>
            <div className={style.content}>
              { props.children }
            </div>
          </>
        )
      }
      {
        props.type === 'tabs' && (
          <Tabs destroyInactiveTabPane className={style.tab}>
            {
              (props.children as React.ReactNode[]).map((i, index) => {
                const ts = props.tabs as WrapperTab[];
                const tab = ts[index]?.label;
                const value = ts[index]?.value;
                return <Tabs.TabPane tab={tab} key={value}>{i}</Tabs.TabPane>;
              })
            }
          </Tabs>
        )
      }
      {
        props.type === undefined && props.children
      }
    </div>
  );
};

export default Wrapper;